import React from "react";
import type { BuilderStepProps } from "campaign-builder/config";
import { CampaignDetailsCard } from "./CampaignDetailsCard";
import { TargetingCard } from "./TargetingCard";
import { D2dMap } from "./D2dMap";

// D2D targeting. Campaign Details (name + single launch date) + the shared
// city/map/areas card, with the D2D polygon map (F5) rendered inside the map
// region. The TargetingProvider lives above the shell (CampaignBuilder) so
// state survives step switches (PAD-31560).
export const D2dTargetingStep: React.ComponentType<BuilderStepProps> = () => (
  <div className="flex flex-col gap-4">
    <CampaignDetailsCard showLaunchDate />
    <TargetingCard>
      <D2dMap />
    </TargetingCard>
  </div>
);
